import e from "react";
import l from "@appchoose/icon";
const c = ({
  value: r
}) => {
  const t = Array(5);
  t.fill(
    /* @__PURE__ */ e.createElement(
      l,
      {
        icon: "starFilled",
        className: "text-green-300",
        "data-testid": "rating-empty"
      }
    ),
    0,
    5
  );
  const n = r > 5 ? 5 : Math.trunc(r);
  for (let a = 0; a < n; a++)
    t[a] = /* @__PURE__ */ e.createElement(
      l,
      {
        icon: "starFilled",
        className: "text-green-900",
        "data-testid": "rating-full"
      }
    );
  const i = r % 1;
  return i >= 0.75 ? t[n] = /* @__PURE__ */ e.createElement(
    l,
    {
      icon: "starFilled",
      className: "text-green-900",
      "data-testid": "rating-full"
    }
  ) : i >= 0.25 && (t[n] = /* @__PURE__ */ e.createElement(
    l,
    {
      icon: "starHalfFilled",
      className: "text-green-900",
      "data-testid": "rating-half"
    }
  )), /* @__PURE__ */ e.createElement("div", { className: "flex space-x-1" }, t.map(
    (a, s) => e.cloneElement(a, { key: s })
  ));
};
c.displayName = "Rating";
export {
  c as default
};
